// AUTO-GENERATED by scripts/generate-route-names.js
// DO NOT EDIT MANUALLY. Regenerated on every npm run dev or build.

export const ROUTE_NAMES = [
  {
    "pattern": "/items/print-center/locations",
    "name": "LocationPrintCenter"
  },
  {
    "pattern": "/settings/rehearsal-templates",
    "name": "Navigate"
  },
  {
    "pattern": "/public/sustainability/:slug",
    "name": "PublicSustainability"
  },
  {
    "pattern": "/auth/sso/:provider/callback",
    "name": "SsoCallback"
  },
  {
    "pattern": "/admin/freelancer-timesheets",
    "name": "ToPeopleHub"
  },
  {
    "pattern": "/financial/season-comparison",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/super-admin/companies/:slug",
    "name": "TenantDetail"
  },
  {
    "pattern": "/productions/:id/pull-sheet",
    "name": "ToProductionTab"
  },
  {
    "pattern": "/productions/:id/call-sheet",
    "name": "ToProductionTab"
  },
  {
    "pattern": "/financial/budget-revisions",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/super-admin/admin-accounts",
    "name": "AdminAccounts"
  },
  {
    "pattern": "/tenant/vendor-credentials",
    "name": "VendorPortalCredentials"
  },
  {
    "pattern": "/admin/calendar-projection",
    "name": "CalendarProjectionDiag"
  },
  {
    "pattern": "/super-admin/system-health",
    "name": "SystemHealth"
  },
  {
    "pattern": "/items/print-center/items",
    "name": "PrintCenter"
  },
  {
    "pattern": "/super-admin/invite-codes",
    "name": "InviteCodesAdmin"
  },
  {
    "pattern": "/super-admin/demo-modules",
    "name": "DemoModules"
  },
  {
    "pattern": "/tours/:id/stops/:stopId",
    "name": "TourStopWorkspace"
  },
  {
    "pattern": "/simple/scan/:type?/:id?",
    "name": "Scan"
  },
  {
    "pattern": "/reports/cost-comparison",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/settings/sustainability",
    "name": "Navigate"
  },
  {
    "pattern": "/productions/:id/budget",
    "name": "ToProductionTab"
  },
  {
    "pattern": "/network/:venue/catalog",
    "name": "VenueCatalog"
  },
  {
    "pattern": "/notifications/settings",
    "name": "Navigate"
  },
  {
    "pattern": "/super-admin/onboarding",
    "name": "OnboardingConfig"
  },
  {
    "pattern": "/super-admin/qa-reports",
    "name": "QAReports"
  },
  {
    "pattern": "/templates/marketplace",
    "name": "TemplateMarketplace"
  },
  {
    "pattern": "/tenant/site-templates",
    "name": "SiteTemplates"
  },
  {
    "pattern": "/simple/pull-sheet/:id",
    "name": "PullSheet"
  },
  {
    "pattern": "/admin/venue-inquiries",
    "name": "VenueInquiriesAdmin"
  },
  {
    "pattern": "/financial/utilization",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/verify-email/confirm",
    "name": "VerifyEmailConfirm"
  },
  {
    "pattern": "/external-productions",
    "name": "ToProductionsView"
  },
  {
    "pattern": "/incoming-productions",
    "name": "ToProductionsView"
  },
  {
    "pattern": "/comms/department/:id",
    "name": "ToCommsGroup"
  },
  {
    "pattern": "/simple/locations/:id",
    "name": "LocationDetail"
  },
  {
    "pattern": "/financial/petty-cash",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/reports/depreciation",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/super-admin/feedback",
    "name": "FeedbackAdmin"
  },
  {
    "pattern": "/super-admin/progress",
    "name": "ProgressDashboard"
  },
  {
    "pattern": "/admin/venue-modules",
    "name": "VenueModules"
  },
  {
    "pattern": "/admin/balance-types",
    "name": "PtoSettings"
  },
  {
    "pattern": "/financial/insurance",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/financial/cash-flow",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/reports/utilization",
    "name": "Navigate"
  },
  {
    "pattern": "/super-admin/support",
    "name": "SupportAdmin"
  },
  {
    "pattern": "/super-admin/billing",
    "name": "BillingOverview"
  },
  {
    "pattern": "/super-admin/metrics",
    "name": "MetricsDashboard"
  },
  {
    "pattern": "/super-admin/modules",
    "name": "PlatformModules"
  },
  {
    "pattern": "/rider-share/:token",
    "name": "SharedRider"
  },
  {
    "pattern": "/items/print-center",
    "name": "PrintCenterHub"
  },
  {
    "pattern": "/kiosk/share/:token",
    "name": "KioskShare"
  },
  {
    "pattern": "/users/:id/activity",
    "name": "UserActivity"
  },
  {
    "pattern": "/admin/date-markers",
    "name": "SuperAdminDateMarkers"
  },
  {
    "pattern": "/financial/explorer",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/admin/lost-damaged",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/financial/forecast",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/items/:id/sticker",
    "name": "ItemSticker"
  },
  {
    "pattern": "/network-inventory",
    "name": "Navigate"
  },
  {
    "pattern": "/department-orders",
    "name": "ToProductionsView"
  },
  {
    "pattern": "/calendar/overview",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/scan/result/:code",
    "name": "QrFieldView"
  },
  {
    "pattern": "/comms/channel/:id",
    "name": "ToCommsGroup"
  },
  {
    "pattern": "/simple/pull-sheet",
    "name": "SimplePullSheetSelect"
  },
  {
    "pattern": "/kiosk/display/:id",
    "name": "KioskDisplay"
  },
  {
    "pattern": "/admin/ai-settings",
    "name": "Navigate"
  },
  {
    "pattern": "/super-admin/usage",
    "name": "UsageMetering"
  },
  {
    "pattern": "/network/requests",
    "name": "NeedsBoard"
  },
  {
    "pattern": "/scan/:type?/:id?",
    "name": "Scan"
  },
  {
    "pattern": "/simple/items/:id",
    "name": "ItemDetail"
  },
  {
    "pattern": "/simple/locations",
    "name": "Locations"
  },
  {
    "pattern": "/settings/billing",
    "name": "BillingSettings"
  },
  {
    "pattern": "/budgets/overview",
    "name": "Navigate"
  },
  {
    "pattern": "/admin/info-pages",
    "name": "Navigate"
  },
  {
    "pattern": "/settings/domains",
    "name": "Navigate"
  },
  {
    "pattern": "/super-admin/logs",
    "name": "LogConsole"
  },
  {
    "pattern": "/forgot-password",
    "name": "ForgotPassword"
  },
  {
    "pattern": "/productions/:id",
    "name": "ProductionDetail"
  },
  {
    "pattern": "/season-overview",
    "name": "ToSeasonOverview"
  },
  {
    "pattern": "/comms/group/:id",
    "name": "ToCommsGroup"
  },
  {
    "pattern": "/comms/space/:id",
    "name": "ToCommsGroup"
  },
  {
    "pattern": "/kiosk/inventory",
    "name": "KioskInventory"
  },
  {
    "pattern": "/admin/audit-log",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/admin/low-stock",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/id-card/:token",
    "name": "SharedIdCard"
  },
  {
    "pattern": "/reset-password",
    "name": "ResetPassword"
  },
  {
    "pattern": "/platform-login",
    "name": "PlatformLogin"
  },
  {
    "pattern": "/items/stickers",
    "name": "BulkSticker"
  },
  {
    "pattern": "/guest-schedule",
    "name": "GuestSchedule"
  },
  {
    "pattern": "/admin/api-keys",
    "name": "ApiKeys"
  },
  {
    "pattern": "companies/:slug",
    "name": "TenantDetail"
  },
  {
    "pattern": "/admin/webhooks",
    "name": "Navigate"
  },
  {
    "pattern": "/notice/:token",
    "name": "RouteErrorBoundary"
  },
  {
    "pattern": "/accept-invite",
    "name": "AcceptInvite"
  },
  {
    "pattern": "/why-stagewise",
    "name": "WhyBrighella"
  },
  {
    "pattern": "/sites/:siteId",
    "name": "SiteDetail"
  },
  {
    "pattern": "/locations/:id",
    "name": "LocationDetail"
  },
  {
    "pattern": "/network/loans",
    "name": "ToMovementsHub"
  },
  {
    "pattern": "/crew/workload",
    "name": "ToPeopleHub"
  },
  {
    "pattern": "/crew/schedule",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/crew-schedule",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/comms/company",
    "name": "ToCommsGroup"
  },
  {
    "pattern": "/notifications",
    "name": "NotificationCenter"
  },
  {
    "pattern": "/kiosk/display",
    "name": "KioskDisplay"
  },
  {
    "pattern": "admin-accounts",
    "name": "AdminAccounts"
  },
  {
    "pattern": "/share/:token",
    "name": "SharedView"
  },
  {
    "pattern": "/guest/:token",
    "name": "SharedView"
  },
  {
    "pattern": "/verify-email",
    "name": "VerifyEmail"
  },
  {
    "pattern": "/me/referrals",
    "name": "MyReferrals"
  },
  {
    "pattern": "/comms/dm/:id",
    "name": "ToCommsChat"
  },
  {
    "pattern": "/simple/items",
    "name": "Items"
  },
  {
    "pattern": "/simple/loans",
    "name": "Loans"
  },
  {
    "pattern": "/simple/check",
    "name": "SimpleCheckInOut"
  },
  {
    "pattern": "/items/import",
    "name": "Import"
  },
  {
    "pattern": "system-health",
    "name": "SystemHealth"
  },
  {
    "pattern": "/info/:token",
    "name": "SharedInfo"
  },
  {
    "pattern": "/join/:token",
    "name": "CommsGuestJoin"
  },
  {
    "pattern": "/productions",
    "name": "Productions"
  },
  {
    "pattern": "/v2/calendar",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/marketplace",
    "name": "Marketplace"
  },
  {
    "pattern": "/support/:id",
    "name": "SupportTicketDetail"
  },
  {
    "pattern": "/admin/plans",
    "name": "PlanEditor"
  },
  {
    "pattern": "/admin/stale",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/maintenance",
    "name": "MaintenanceDashboard"
  },
  {
    "pattern": "/super-admin",
    "name": "PlatformLayout"
  },
  {
    "pattern": "invite-codes",
    "name": "InviteCodesAdmin"
  },
  {
    "pattern": "demo-modules",
    "name": "DemoModules"
  },
  {
    "pattern": "/me/id-card",
    "name": "IdCard"
  },
  {
    "pattern": "/events/:id",
    "name": "EventDetail"
  },
  {
    "pattern": "/spaces/:id",
    "name": "SpaceDetail"
  },
  {
    "pattern": "/green-book",
    "name": "GreenBookHub"
  },
  {
    "pattern": "/riders/:id",
    "name": "RiderEditor"
  },
  {
    "pattern": "/cables/:id",
    "name": "Cables"
  },
  {
    "pattern": "/kiosk/sort",
    "name": "KioskSort"
  },
  {
    "pattern": "/items/:id",
    "name": "ItemDetail"
  },
  {
    "pattern": "/templates",
    "name": "Templates"
  },
  {
    "pattern": "/movements",
    "name": "MovementsHub"
  },
  {
    "pattern": "/locations",
    "name": "Locations"
  },
  {
    "pattern": "/tours/:id",
    "name": "TourWorkspace"
  },
  {
    "pattern": "groups/:id",
    "name": "CommsGroups"
  },
  {
    "pattern": "/documents",
    "name": "Documents"
  },
  {
    "pattern": "/financial",
    "name": "ToReportsHub"
  },
  {
    "pattern": "/admin/pto",
    "name": "ToPeopleHub"
  },
  {
    "pattern": "onboarding",
    "name": "OnboardingConfig"
  },
  {
    "pattern": "qa-reports",
    "name": "QAReports"
  },
  {
    "pattern": "/wishlist",
    "name": "Wishlist"
  },
  {
    "pattern": "/help/:id",
    "name": "Help"
  },
  {
    "pattern": "/borrowed",
    "name": "ToMovementsHub"
  },
  {
    "pattern": "/calendar",
    "name": "CalendarHub"
  },
  {
    "pattern": "/schedule",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/my-hours",
    "name": "MyHours"
  },
  {
    "pattern": "/comms/dm",
    "name": "ToCommsChat"
  },
  {
    "pattern": "/handbook",
    "name": "CompanyHandbook"
  },
  {
    "pattern": "/nfc-tags",
    "name": "NfcTags"
  },
  {
    "pattern": "/admin/ai",
    "name": "Navigate"
  },
  {
    "pattern": "/privacy",
    "name": "PrivacyPolicy"
  },
  {
    "pattern": "/bundles",
    "name": "Bundles"
  },
  {
    "pattern": "/budgets",
    "name": "Budgets"
  },
  {
    "pattern": "/artists",
    "name": "Artists"
  },
  {
    "pattern": "/network",
    "name": "Network"
  },
  {
    "pattern": "/s/:code",
    "name": "QrResolve"
  },
  {
    "pattern": "chat/:id",
    "name": "CommsChat"
  },
  {
    "pattern": "contacts",
    "name": "ContactsList"
  },
  {
    "pattern": "/support",
    "name": "SupportTickets"
  },
  {
    "pattern": "/reports",
    "name": "ReportsHub"
  },
  {
    "pattern": "feedback",
    "name": "FeedbackAdmin"
  },
  {
    "pattern": "progress",
    "name": "ProgressDashboard"
  },
  {
    "pattern": "/signup",
    "name": "Signup"
  },
  {
    "pattern": "/events",
    "name": "Events"
  },
  {
    "pattern": "/season",
    "name": "ToSeasonOverview"
  },
  {
    "pattern": "/spaces",
    "name": "Spaces"
  },
  {
    "pattern": "/riders",
    "name": "Riders"
  },
  {
    "pattern": "/people",
    "name": "PeopleHub"
  },
  {
    "pattern": "/cables",
    "name": "Cables"
  },
  {
    "pattern": "/simple",
    "name": "SimpleHome"
  },
  {
    "pattern": "support",
    "name": "SupportAdmin"
  },
  {
    "pattern": "billing",
    "name": "BillingOverview"
  },
  {
    "pattern": "metrics",
    "name": "MetricsDashboard"
  },
  {
    "pattern": "modules",
    "name": "PlatformModules"
  },
  {
    "pattern": "/login",
    "name": "Login"
  },
  {
    "pattern": "/terms",
    "name": "TermsOfService"
  },
  {
    "pattern": "/items",
    "name": "Items"
  },
  {
    "pattern": "/loans",
    "name": "ToMovementsHub"
  },
  {
    "pattern": "/sites",
    "name": "Sites"
  },
  {
    "pattern": "/daily",
    "name": "ToCalendarHub"
  },
  {
    "pattern": "/tours",
    "name": "TourList"
  },
  {
    "pattern": "/comms",
    "name": "CommsShell"
  },
  {
    "pattern": "groups",
    "name": "CommsGroups"
  },
  {
    "pattern": "/todos",
    "name": "Todos"
  },
  {
    "pattern": "/kiosk",
    "name": "KioskRoute"
  },
  {
    "pattern": "/users",
    "name": "ToPeopleHub"
  },
  {
    "pattern": "/admin",
    "name": "SettingsHub"
  },
  {
    "pattern": "/help",
    "name": "Help"
  },
  {
    "pattern": "/feed",
    "name": "ToCommsFeed"
  },
  {
    "pattern": "/rent",
    "name": "RentVenue"
  },
  {
    "pattern": "usage",
    "name": "UsageMetering"
  },
  {
    "pattern": "/dpa",
    "name": "DataProcessingAgreement"
  },
  {
    "pattern": "feed",
    "name": "CommsFeed"
  },
  {
    "pattern": "chat",
    "name": "CommsChat"
  },
  {
    "pattern": "logs",
    "name": "LogConsole"
  },
  {
    "pattern": "/",
    "name": "RootRoute"
  },
  {
    "pattern": "*",
    "name": "NotFound"
  }
]

export function matchRouteName(pathname) {
  for (const { pattern, name } of ROUTE_NAMES) {
    if (pattern === "*") return name
    const regex = new RegExp("^" + pattern.replace(/:[^/]+/g, "[^/]+").replace(/[.+?^${}()|[\\]\\]/g, "\\$&") + "$")
    if (regex.test(pathname)) return name
  }
  return null
}
